/** Teksty nagłówków widoków (Hero 2.0): grupa work (zadania, alerty, akceptacje). Klucze: heroWork.* */
export const heroWorkPl = {
  tasks: {
    today: 'Na dziś',
    todayHint: 'zadania z terminem dziś',
    overdue: 'Zaległe',
    overdueHint: 'wymagają reakcji',
    overdueNone: 'brak zaległości',
    upcoming: 'Nadchodzące',
    upcomingHint: 'z terminem po dzisiaj',
    rate: 'Realizacja 7 dni',
    rateHint: '{done} z {total} zadań z ostatnich 7 dni',
    rateNone: 'brak zadań z ostatnich 7 dni',
    insightOverdue: 'Zaległe zadania: {count}. Zacznij od najstarszych, zanim klienci odczują brak kontaktu.',
    insightLowRate: 'Zrealizowano {pct} zadań z ostatnich 7 dni ({done} z {total}). Zaplanuj blok czasu na domykanie otwartych spraw.',
    insightToday: 'Na dziś zaplanowano zadania: {count}. Domknij je przed końcem dnia.',
    insightUpcoming: 'Na dziś czysto. Nadchodzące zadania: {count}, możesz się do nich przygotować.',
    insightClear: 'Wszystko na bieżąco — brak zadań na dziś i brak zaległości.',
    showOverdue: 'Pokaż zaległe',
    showToday: 'Pokaż dzisiejsze',
    showUpcoming: 'Pokaż nadchodzące',
    actions: { add: 'Nowe zadanie', customers: 'Klienci', alerts: 'Alerty' },
  },
  alerts: {
    critical: 'Krytyczne',
    criticalOldest: 'najstarszy od {age}',
    criticalNone: 'brak krytycznych',
    warning: 'Ostrzeżenia',
    warningHint: 'plus {info} informacyjnych',
    opportunity: 'Szanse sprzedażowe',
    opportunityHint: 'do wykorzystania',
    resolved: 'Rozwiązane',
    resolvedHint: '{pct} wszystkich alertów',
    resolvedNone: 'jeszcze brak rozwiązanych',
    insightCritical: 'Krytyczne alerty otwarte: {count}, najstarszy od {age}. Zajmij się nimi w pierwszej kolejności.',
    insightCriticalNoAge: 'Krytyczne alerty otwarte: {count}. Zajmij się nimi w pierwszej kolejności.',
    insightWarning: 'Ostrzeżenia do przejrzenia: {count}. Zareaguj, zanim przejdą w krytyczne.',
    insightOpportunity: 'Szanse sprzedażowe: {count}. Każda to potencjalne dodatkowe zamówienie.',
    insightClear: 'Brak otwartych alertów — portfel klientów wygląda stabilnie.',
    showCritical: 'Pokaż krytyczne',
    showWarning: 'Pokaż ostrzeżenia',
    showOpportunity: 'Pokaż szanse',
    actions: { tasks: 'Zaległe zadania', customers: 'Klienci', recompute: 'Przelicz alerty' },
  },
  workflow: {
    waiting: 'Czeka na mnie',
    waitingHint: 'wnioski do mojej decyzji',
    waitingNone: 'nic nie czeka',
    mine: 'Moje wnioski',
    mineHint: 'złożone przeze mnie',
    inProgress: 'W obiegu',
    inProgressHint: 'wnioski w trakcie akceptacji',
    approved: 'Zatwierdzone w miesiącu',
    approvedHint: 'odrzucone: {rejected}',
    avgTime: 'Średni czas decyzji',
    avgTimeHint: 'z {count} zatwierdzonych wniosków',
    avgTimeNone: 'brak zatwierdzonych wniosków',
    insightWaiting: 'Wnioski czekające na Twoją decyzję: {count}, najstarszy od {age}. Zablokowany krok wstrzymuje wdrożenie klienta.',
    insightRejected: 'W tym miesiącu odrzucono wnioski: {count}. Sprawdź uwagi akceptujących przed ponownym zgłoszeniem.',
    insightActive: 'Wnioski w obiegu: {count}, najstarszy czeka od {age}. Przypomnij osobie akceptującej, jeśli to potrwa dłużej.',
    insightClear: 'Brak otwartych wniosków — możesz zgłosić nowego klienta do akceptacji.',
    showPending: 'Pokaż oczekujące',
    showReturned: 'Pokaż do poprawy',
    insightReturned: 'Wnioski zwrócone do uzupełnienia: {count}. Popraw dane zgodnie z uwagami działów i wyślij je ponownie.',
    showActive: 'Pokaż wszystkie',
    actions: { newCustomer: 'Nowy klient', leads: 'Leady', customers: 'Klienci' },
  },
  request: {
    status: 'Status',
    step: 'Krok',
    stepHint: '{done} z {total} zatwierdzonych · czeka: {name}',
    stepDone: 'wszystkie kroki zatwierdzone',
    age: 'Wiek wniosku',
    ageOpen: 'od zgłoszenia',
    ageClosed: 'czas do zakończenia',
    requester: 'Zgłaszający',
    requesterHint: 'zgłoszono {date}',
    lessThanHour: '< 1 godz.',
    hours: '{count} godz.',
    insightMine: 'Wniosek czeka na Twoją decyzję (czekają: {step}) — od {age}.',
    insightOverdue: 'Krok „{step}” przekroczył termin decyzji o {age}.',
    insightWaiting: 'Wniosek czeka na decyzję działów: {step} — od {age}.',
    insightApproved: 'Wniosek zatwierdzony w {age}. Klient jest gotowy do eksportu do systemu ERP.',
    insightApprovedErp: 'Wniosek zatwierdzony w {age}. Dane klienta zostały przygotowane do eksportu do ERP.',
    insightRejected: 'Wniosek odrzucony w kroku „{step}”. Sprawdź komentarz i zgłoś go ponownie po poprawkach.',
    insightCancelled: 'Wniosek został anulowany przez zgłaszającego.',
    insightReturned: 'Wniosek zwrócony do uzupełnienia przez: {areas}. Czeka na poprawki zgłaszającego.',
    insightReturnedMine: 'Wniosek zwrócony do uzupełnienia przez: {areas}. Popraw dane i wyślij ponownie.',
    actions: { customer: 'Karta klienta', lead: 'Lead', list: 'Lista wniosków' },
  },
  wizard: {
    step: 'Krok',
    stepHint: 'z {total} · {name}',
    fields: 'Wymagane pola',
    fieldsHint: 'do uzupełnienia: {missing}',
    fieldsDone: 'komplet danych',
    draft: 'Wersja robocza',
    draftHint: 'zapis lokalny w przeglądarce',
    draftNone: 'jeszcze nie zapisano',
    insightErrors: 'Formularz zawiera błędy w krokach: {count}. Popraw je przed wysłaniem.',
    insightReady: 'Komplet danych — sprawdź podsumowanie i wyślij wniosek do akceptacji.',
    insightMissing: 'Do uzupełnienia pozostało wymaganych pól: {missing}. Im pełniejszy wniosek, tym szybsza akceptacja.',
    insightFlow: 'Wniosek trafi równolegle do trzech działów: Handlowy (ceny i limit), Logistyka i Zamówienia.',
  },
};

export const heroWorkEn: typeof heroWorkPl = {
  tasks: {
    today: 'Due today',
    todayHint: 'tasks due today',
    overdue: 'Overdue',
    overdueHint: 'need action',
    overdueNone: 'nothing overdue',
    upcoming: 'Upcoming',
    upcomingHint: 'due after today',
    rate: '7-day completion',
    rateHint: '{done} of {total} tasks from the last 7 days',
    rateNone: 'no tasks in the last 7 days',
    insightOverdue: 'Overdue tasks: {count}. Start with the oldest before customers feel the lack of contact.',
    insightLowRate: '{pct} of tasks from the last 7 days were completed ({done} of {total}). Block some time to close open items.',
    insightToday: 'Tasks due today: {count}. Wrap them up before the end of the day.',
    insightUpcoming: 'Today is clear. Upcoming tasks: {count}, so you can prepare.',
    insightClear: 'All caught up — nothing due today and nothing overdue.',
    showOverdue: 'Show overdue',
    showToday: 'Show today',
    showUpcoming: 'Show upcoming',
    actions: { add: 'New task', customers: 'Customers', alerts: 'Alerts' },
  },
  alerts: {
    critical: 'Critical',
    criticalOldest: 'oldest for {age}',
    criticalNone: 'no critical alerts',
    warning: 'Warnings',
    warningHint: 'plus {info} informational',
    opportunity: 'Sales opportunities',
    opportunityHint: 'ready to act on',
    resolved: 'Resolved',
    resolvedHint: '{pct} of all alerts',
    resolvedNone: 'nothing resolved yet',
    insightCritical: 'Open critical alerts: {count}, the oldest for {age}. Handle them first.',
    insightCriticalNoAge: 'Open critical alerts: {count}. Handle them first.',
    insightWarning: 'Warnings to review: {count}. Act before they turn critical.',
    insightOpportunity: 'Sales opportunities: {count}. Each one is a potential extra order.',
    insightClear: 'No open alerts — the customer portfolio looks stable.',
    showCritical: 'Show critical',
    showWarning: 'Show warnings',
    showOpportunity: 'Show opportunities',
    actions: { tasks: 'Overdue tasks', customers: 'Customers', recompute: 'Recompute alerts' },
  },
  workflow: {
    waiting: 'Waiting for me',
    waitingHint: 'requests for my decision',
    waitingNone: 'nothing waiting',
    mine: 'My requests',
    mineHint: 'submitted by me',
    inProgress: 'In progress',
    inProgressHint: 'requests being approved',
    approved: 'Approved this month',
    approvedHint: 'rejected: {rejected}',
    avgTime: 'Average decision time',
    avgTimeHint: 'from {count} approved requests',
    avgTimeNone: 'no approved requests yet',
    insightWaiting: 'Requests waiting for your decision: {count}, the oldest for {age}. A blocked step holds up customer onboarding.',
    insightRejected: 'Requests rejected this month: {count}. Review the approvers’ comments before resubmitting.',
    insightActive: 'Requests in progress: {count}, the oldest waiting for {age}. Nudge the approver if it drags on.',
    insightClear: 'No open requests — you can submit a new customer for approval.',
    showPending: 'Show pending',
    showReturned: 'Show to fix',
    insightReturned: 'Requests returned for completion: {count}. Fix the data according to the departments’ comments and resubmit.',
    showActive: 'Show all',
    actions: { newCustomer: 'New customer', leads: 'Leads', customers: 'Customers' },
  },
  request: {
    status: 'Status',
    step: 'Step',
    stepHint: '{done} of {total} approved · waiting: {name}',
    stepDone: 'all steps approved',
    age: 'Request age',
    ageOpen: 'since submission',
    ageClosed: 'time to completion',
    requester: 'Requested by',
    requesterHint: 'submitted {date}',
    lessThanHour: '< 1 h',
    hours: '{count} h',
    insightMine: 'This request awaits your decision (waiting: {step}) — for {age}.',
    insightOverdue: 'Step “{step}” is {age} past its decision deadline.',
    insightWaiting: 'The request is waiting for the decision of: {step} — for {age}.',
    insightApproved: 'Request approved in {age}. The customer is ready for export to the ERP system.',
    insightApprovedErp: 'Request approved in {age}. Customer data has been prepared for ERP export.',
    insightRejected: 'Request rejected at step “{step}”. Check the comment and resubmit after the fixes.',
    insightCancelled: 'The request was cancelled by the requester.',
    insightReturned: 'Returned for completion by: {areas}. Waiting for the requester’s corrections.',
    insightReturnedMine: 'Returned for completion by: {areas}. Fix the data and resubmit.',
    actions: { customer: 'Customer card', lead: 'Lead', list: 'All requests' },
  },
  wizard: {
    step: 'Step',
    stepHint: 'of {total} · {name}',
    fields: 'Required fields',
    fieldsHint: 'left to fill: {missing}',
    fieldsDone: 'all data provided',
    draft: 'Draft',
    draftHint: 'saved locally in the browser',
    draftNone: 'not saved yet',
    insightErrors: 'The form has errors in steps: {count}. Fix them before submitting.',
    insightReady: 'All data provided — check the summary and submit the request for approval.',
    insightMissing: 'Required fields left to fill: {missing}. The more complete the request, the faster the approval.',
    insightFlow: 'The request goes in parallel to three departments: Sales (prices and limit), Logistics and Orders.',
  },
};
